import { Link } from 'react-router-dom';

const stats = [
  { value: '500,000+', label: '注册用户', icon: 'ri-user-heart-line' },
  { value: '1,200+', label: '优质文章', icon: 'ri-article-line' },
  { value: '300+', label: '线下活动', icon: 'ri-calendar-check-line' },
  { value: '98%', label: '用户满意度', icon: 'ri-emotion-happy-line' },
];

export default function StatsSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-primary-500">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-background-50 font-heading mb-3">
            我们的影响力
          </h2>
          <p className="text-background-50/80 text-sm md:text-base max-w-lg mx-auto">
            用数据说话，男同网正在成为越来越多男同朋友值得信赖的社群平台
          </p>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center p-4 md:p-6 rounded-lg bg-background-50/10 backdrop-blur-sm">
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center">
                <i className={`${stat.icon} text-3xl text-background-50`}></i>
              </div>
              <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading mb-1">
                {stat.value}
              </div>
              <div className="text-sm text-background-50/80">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
        <div className="text-center mt-10">
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 text-primary-600 rounded-full text-sm font-medium whitespace-nowrap hover:bg-background-100 transition-colors cursor-pointer"
          >
            了解更多关于我们
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}